export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10181.936f0b79.jpg";